import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { getDataExportTypes } from '../../redux/actions';
import componentBase from '../../../../src/lib/component-base';
import Category from './children/Category/Category';
import historicalIcon from '../../../../static/images/menu-icons/Historical-Icon-WHITE.svg';
import contactIcon from '../../../../static/images/data-export-icons/FAQ-Icon-WHITE.svg';
import developerIcon from '../../../../static/images/data-export-icons/Developer-Icon-WHITE.svg';
import needAnAPIBackground from '../../../../static/images/data-export-icons/NeedAnAPI-BannerBackground.png';
import DataExportsHeader from '../shared/DataExportsHeader';
import PageFooterAd from '../../../../shared/components/PageFooterAd/PageFooterAd';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
import { DataExports as DataExportsAds } from '../ads';


const exportTypesIcons = {
  historical: historicalIcon,
};

@connect(state => ({
  exportTypes: state.DataExports.dataExportTypes,
}))
@componentBase('NewDataExports')
export default class NewDataExports extends Component {
  static propTypes = {
    exportTypes: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.object,
    name: PropTypes.string,
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getDataExportTypes());
  }

  renderCategories = () => {
    if (this.props.exportTypes) {
      const { categories } = this.props.exportTypes;
      if (categories) {
        return categories.map((category, index) => {
          const key = `${category}${index}`;

          return (
            <Category
              key={key}
              title={category.name}
              icon={exportTypesIcons[category.type]}
              push={this.props.history.push}
              types={category.exportTypes}
              dispatch={this.props.dispatch}
            />
          );
        });
      }
    }
    return null;
  }

  render = () => {
    const subscriptionActive = (
      this.context &&
      this.context.currentUser &&
      this.context.currentUser.subscriptionActive
    );

    const adUnits = {
      mobileAd: DataExportsAds.topMobile,
      desktopAd: DataExportsAds.top,
    };

    return (
      <div className='newDataExports'>
        <Helmet title='New Data Exports' />
        <BannerAd
          topAd
          {...adUnits}
          subscriptionActive={subscriptionActive}
          style={{ marginBottom: '-10px' }}
        />
        <DataExportsHeader
          primaryText='New Data Export'
          secondaryText='Select the type of export you are interested in'
        />
        {this.renderCategories()}
        <PageFooterAd
          title={'Not finding what you\'re looking for?'}
          icon={contactIcon}
          subtitle='Contact us for different export needs, or large custom export projects.'
          buttonTitle='contact a representative'
          buttonHref='https://www.flightstats.com/company/contact/contact-a-representative-about-data-exports/'
          containerClass='data-export-contact-container'
          buttonColor='rgb(109,216,54)'
        />

        <PageFooterAd
          title='Need an API?'
          icon={developerIcon}
          subtitle='Historical Flight Status information is also available via our APIs.'
          buttonTitle='visit our developer center'
          buttonHref='https://developer.flightstats.com/api-docs/historical-flight-status/v3'
          containerClass='data-export-dev-center-container'
          backgroundImage={needAnAPIBackground}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/NewDataExports/NewDataExportsContainer.js